import React from 'react';

export default function PassGroupTable (props) {

    return (
        <>
            <table className="passInfoTableWrap">
                <caption>{props.data.caption}</caption>
                <thead>
                <tr>
                    {
                        props.data.products.map((product, index) => {
                            return product.name
                                ? (<th scope="col" key={`pass-group-table-th-${index}`}>
                                        <div className="passInfoTable_title">
                                            {product.name}
                                            <strong className={`passInfoTable_number${product.color}`}>{product.price}</strong>
                                        </div>
                                    </th>)
                                : (<th key={`pass-group-table-th-${index}`} className="passInfoTable_empty">&nbsp;</th>)
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    props.data.support.map((support, index) => {
                        return support.info
                            && (<tr key={`pass-group-table-tb-${index}`}>
                                    <th scope="row">
                                        <div className="passInfoTable_title">
                                            {
                                                support.info.split("\n").map((line) => {
                                                    return (
                                                        <span>{line}<br/></span>
                                                    );
                                                })
                                            }
                                            {support.label && (<span className="passModule-label">{support.label}</span>)}
                                        </div>
                                    </th>
                                    {
                                        support.value.map((value, index) => {
                                            let valueClassName = value == 'false' ? 'passInfoTable_false' : 'passInfoTable_' + value;
                                            return (<td key={`pass-group-table-th-support-${index}`}><span className={valueClassName}><i className="hide">{value == 'true' ? '0' : 'X'}</i></span></td>)
                                        })
                                    }
                                </tr>)
                    })
                }
                </tbody>
            </table>
        </>
    );
}
